<template>
  <span class="m-numeric">{{ formattedValue }}</span>
</template>

<script>
  import FormatNumberMixin from 'legacy/mixins/components/FormatNumberMixin';
  import applyVat from 'utils/number/applyVat';
  import BigNumber from 'bignumber.js';

  export default {
    name: 'MNumeric',
    mixins: [FormatNumberMixin],
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      alwaysSign: {
        type: Boolean,
        default: false
      },
      trueMinusSign: {
        type: Boolean,
        default: true
      },
      vat: {
        type: [Boolean, Object, BigNumber],
        default: false
      },
      showCurrencySymbol: {
        type: Boolean,
        default: true
      },
      shortenNumber: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      valueWithVat () {
        if (this.vat) {
          return applyVat(this.value, this.vat);
        }
        return this.value;
      },
      formattedValue () {
        let result;
        if (this.trueMinusSign && this.valueWithVat < 0) {
          result = `−${this.getFormattedNumber(Math.abs(this.valueWithVat), {
            withCurrencySymbol: this.showCurrencySymbol,
            shortenNumber: this.shortenNumber
          })}`;
        } else {
          result = this.getFormattedNumber(Number(this.valueWithVat), {
            withCurrencySymbol: this.showCurrencySymbol,
            shortenNumber: this.shortenNumber
          });
        }
        if (this.alwaysSign && this.valueWithVat > 0) {
          result = `+${result}`;
        }
        return result;
      }
    }
  };
</script>
